/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_Error_MecaInputs */



/**
* | output |
* | --- |
* | "No head th. in the room must have a mechanical error" |
*
* @param {Calibration_Temperature_Error_MecaInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_error_meca = /** @type {((inputs?: Calibration_Temperature_Error_MecaInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Error_MecaInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No head th. in the room must have a mechanical error")
	return /** @type {LocalizedString} */ ("Aucune tête th. de la pièce ne doit présenter d'erreur mécanique")
});